import { render, staticRenderFns } from "./user-box.vue?vue&type=template&id=b023b106"
import script from "./user-box.vue?vue&type=script&lang=js"
export * from "./user-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports